import { InvoiceScansRepository } from '../repositories/invoice_scans.repository'
import { GetInvoiceScanResponseT } from '../types/invoice_scans.types'
import { PretensionByNumResponseT } from '@/core/types/pretensions.types'

const invoiceScansRepository = new InvoiceScansRepository()

export class InvoiceScansService {
    async getScan(invoice_number: string): Promise<GetInvoiceScanResponseT> {
        const response = await invoiceScansRepository.getScan(invoice_number)
        return response.data
    }

    async saveScan(invoice_number: string, file: File, fileType: number): Promise<void> {
        const response = await invoiceScansRepository.saveScan(invoice_number, file, fileType)
        return response.data
    }

    async getInfoByNum(invoiceNumber: string): Promise<PretensionByNumResponseT> {
        const response = await invoiceScansRepository.getInfoByNum(invoiceNumber)
        return response.data
    }
}
